import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  username = '';

  updateUsername = (userName: string) => {
    this.username = userName;
  };
}
